

import DescriptionOutlinedIcon from "@mui/icons-material/DescriptionOutlined";
import { AuthenticatedLayout } from "../../layouts";
import { NewsSetup } from "../../components/NewsSetup";


export const NewsSetupPage = () => {
  return (
    <AuthenticatedLayout
      pageTitle="News"
      pageTitleIcon={<DescriptionOutlinedIcon />}
      breadcrumbCurrentPageName=""
      breadcrumbLinks={[
        { text: "News", navigateTo: "/news" }
      ]}
      mainContents={<NewsSetup />}
    />
  );
};
